export const ERROR_MESSAGES = {
    ACCESS_CODE: 'form.validation_error_message.access_code',
    AUTH_FAILED_1: 'form.validation_error_message.authenticationFailed_1',
    NOT_VALID: 'form.validation_error_message.not_valid',
    REQUIRED: 'form.validation_error_message.required',
    SSN: 'ssap.validation_error_message.ssn',
    UNIQUE_SSN: 'ssap.validation_error_message.unique_ssn'
};
